import { mdiAccountCircle } from '@mdi/js'

import { MdiIcon } from 'components/Icons'
import { ProfileImg, StyledUserImgContainer } from './styles'
import theme from 'theme_'

interface UserImgContainerProps {
  profilePicUrl?: string | null
  /**
   * Width and Height of icon in pixels
   */
  size?: number
}

function UserImgContainer(props: UserImgContainerProps) {
  const imgSize = props.size || 120

  return (
    <StyledUserImgContainer size={imgSize}>
      {props.profilePicUrl ? (
        <ProfileImg
          size={imgSize}
          src={props.profilePicUrl}
          alt="Profile picture"
        />
      ) : (
        <MdiIcon
          path={mdiAccountCircle}
          color={theme.colors.duneWarmGrey}
          size={imgSize + 'px'}
        />
      )}
    </StyledUserImgContainer>
  )
}

export default UserImgContainer
